import { render, staticRenderFns } from "./AcceptInvitaion.vue?vue&type=template&id=64dd51dc&scoped=true"
import script from "./AcceptInvitaion.vue?vue&type=script&lang=js"
export * from "./AcceptInvitaion.vue?vue&type=script&lang=js"
import style0 from "./AcceptInvitaion.vue?vue&type=style&index=0&id=64dd51dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dd51dc",
  null
  
)

export default component.exports